// Treat "", "NULL" (case-insensitive) as undefined, otherwise trimmed string
export const toOptionalString = (value) => {
    if (value == null)
        return undefined;
    const string = String(value).trim();
    if (!string || string.toLowerCase() === "null")
        return undefined;
    return string;
};
